module.exports = __webpack_public_path__ + "img/STAKE.48a08264.svg";